/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

import NudgeBanner from 'bundles/degree-home/components/v3-dpm/components/NudgeBanner';
import useNudge from 'bundles/degree-home/components/v3-dpm/lib/useNudge';

const styles = {
  container: (theme: Theme) => css`
    ${theme.breakpoints.down('xs')} {
      margin-bottom: calc(-1 * ${theme.spacing(32)});
    }
  `,
};

const NudgeBannerRenderer: React.VFC = () => {
  const displayableEvents = useNudge();

  return (
    <div css={styles.container}>
      {displayableEvents.map((event) => (
        <NudgeBanner key={event.id} academicEvent={event} />
      ))}
    </div>
  );
};

export default NudgeBannerRenderer;
